export type Booking = {
  additionalterms: any[];
  adminManager?: AdminManager;
  approvedAnnualRent: string;
  autoPayData: any[];
  billingSchedule: any[];
  bookingExpiryInHours: number;
  bookingExtensionApproval: string;
  bookingId: number;
  bookingPayments: any[];
  bookingTerms: BookingTerms;
  bookingType: string;
  businessUnitId: string;
  courierWaivedForRenewal: string;
  createdAt: string;
  createdBy: string;
  currency: string;
  customFields?: Record<string, unknown>;
  customPaymentSchedule: any[];
  deletedDocuments: any[];
  depositPayments: any[];
  directDebit: boolean;
  documents: any[];
  earlyTerminationRequestStatus?: string;
  ejariIntegration: boolean;
  ejariProcessed: boolean;
  emiratesIdExpiryNoticeSent: boolean;
  externalAgent: string;
  formState: number;
  gatewayTransactionHistory: any[];
  isAgp: string;
  isAutoPayActive: boolean;
  isBookingConfirm: boolean;
  isDeleted: boolean;
  isPaymentGateway: boolean;
  isPDCCourier: boolean;
  isPdcPayNow: string;
  isSignatory: string;
  kycDetails: KycDetails;
  landlordId: string;
  leaseDocumentsHistory: any[];
  leaseId: string;
  leaseManager: LeaseManager;
  leaseManagerApproval: string;
  leaseStatus: string;
  leaseStatusHistory: LeaseStatusHistory[];
  leaseSubStatus: LeaseSubStatus;
  leaseTerms: LeaseTerms;
  leaseType: string;
  loginUserType: string;
  managerApproval: string;
  managersManager: ManagersManager;
  orgId: string;
  parkings: any[];
  passportExpiryNoticeSent: boolean;
  paymentPlan: PaymentPlan[];
  paymentPlanApproval: string;
  paymentSchedule: PaymentSchedule[];
  portalDocuments: any[];
  propertyBookingPaymentTypes: any[];
  propertyDetails: PropertyDetails;
  propertyId: string;
  renewalNoticeDays: number;
  renewalStatus?: string;
  renewalTerms?: RenewalTerms;
  requiredDocuments: RequiredDocument[];
  securityDepositPaidPercentageLimit?: number;
  sendBookingFormOnApproval: boolean;
  sharedContacts: any[];
  shippingDetails: Array<ShippingDetail[]>;
  shippingProcessed: boolean;
  shippingStatus: string;
  signatoryUser: Record<string, unknown>;
  status: string;
  tenantDetails: TenantDetails;
  tenantId: string;
  torType?: string;
  totalSecurityDepositPaid?: number;
  trLicenseExpiryNoticeSent: boolean;
  uaePassSignedLandlord: boolean;
  uaePassSignedTenant: boolean;
  unitId: string;
  unitStatus: string;
  updatedAt: string;
  updatedBy: string;
  upfrontFirstInstallment: string;
  upfrontFirstInstallmentRenewal: string;
  visaExpiryNoticeSent: boolean;
};

export type BookingTerms = {
  amountChange?: number;
  amountType?: string;
  annualBaseRent: number;
  billingCharges: unknown[];
  bookingEndDate: string;
  bookingStartDate: string;
  changeValue?: string;
  contractRent?: number;
  numberOfInstallments: number;
  numberOfRenewalTerms?: number;
  renewalAmount?: number;
  securityDepositTopUp?: SecurityDepositTopUp;
  durationType?: string;
};

export type SecurityDepositTopUp = {
  currentAmount: number;
  requiredAmount: number;
  requiredPercentage: number | string;
};

export type RenewalTerms = {
  renewalNotifiedToTenant: number;
  tempAmountChange: number;
  tempAmountType: string;
  tempAnnualBaseRent: number;
  tempChangeValue: string;
  tempNumberOfInstallments: number;
  tempRenewalAmount: number;
};

export type KycDetails = {
  employer: string;
  gender: string;
  jobTitle: string;
};

export type LeaseManager = {
  countryCode: string;
  email: string;
  mobile: string;
  name: string;
  userId: string;
};

export type LeaseStatusHistory = {
  comments?: string;
  createdAt: string;
  status: string;
  updatedAt: string;
  updatedBy: string;
  updatedById: string;
};

export type LeaseSubStatus = {
  actor: string;
  status: string;
};

export type LeaseTerms = {
  contractAmount: number;
  createdAt: string;
  ejariProcessing: string;
  fitOutEndDate?: string;
  fitOutStartDate?: string;
  leaseEndDate: string;
  leaseNature: string;
  leaseStartDate: string;
  leaseType: string;
  commencementDate: string;
  moveInDate: string;
  moveInDateConfirm: string;
  noOfCheques: number;
  noOfFreeParkingSlots: number;
  noOfPaidParkingSlots: number;
  rentFreeEndDate?: string;
  rentFreeStartDate?: string;
  rentFreePeriod?: string;
  securityDeposit: number;
  updatedAt: string;
};

export type ManagersManager = {
  email: string;
  name: string;
  userId: string;
};

export type PaymentPlan = {
  annualRent: number;
  createdAt: string;
  installments: number;
  noOfYear: number;
  oldAnnualRent: number;
  oldSecurityDeposit: number;
  paymentPlanId: string;
  securityDeposit?: number;
  updatedAt: string;
};

export type PaymentSchedule = {
  actualAmount: number;
  bankName?: string;
  beneficiaryAccount: string;
  beneficiaryName: string;
  businessUnitId: string;
  chequeDate: string;
  chequeNumber: string;
  chequeStatus: string;
  createdAt: string;
  createdBy: string;
  creditCardProcessingfee?: number;
  depositDate?: string;
  depositTo: string;
  depositToAccountNumber: string;
  depositToBank: string;
  description: string;
  documentNo: string;
  dueDate: string;
  installments: number;
  isDeleted: boolean;
  isPdcPayNow: string;
  isPDCVerified: boolean;
  landlordId: string;
  leaseId: string;
  lessorAccountNumber: string;
  lessorBankName: string;
  modeOfPayment: string;
  orgId: string;
  paidDate?: string;
  paidFrom: string;
  payableto: string;
  paymentNote: string;
  paymentStatus: string;
  pdcId: string;
  platformFee: number;
  propertyDetails: PropertyDetails;
  propertyId: string;
  source: string;
  status: string;
  statusHistory: StatusHistory[];
  tenantId: string;
  totalAmount: number;
  totalCreditCardAmount?: number;
  unitId: string;
  updatedAt: string;
  updatedBy: string;
  vat: number;
  yearNumber: number;
};

export type PropertyDetails = {
  address: Address;
  areaSqft: string;
  createdAt: string;
  dewa: string;
  financialDimensions?: Record<string, unknown>;
  isDirectDebitEnable?: boolean;
  parkingUnit: any[];
  propertyName: string;
  referralapprovalcode: string;
  unitCode: string;
  unitNumber: string;
  unitSubType: string;
  unitType: string;
  updatedAt: string;
  usagesType: UsageType;
};

export type Address = {
  addressLine1: string;
  addressLine2: string;
  community: string;
  country: string;
  createdAt: string;
  emirates: string;
  latitude: string;
  longitude: string;
  updatedAt: string;
};

export type StatusHistory = {
  bankName: string;
  comments: string;
  createdAt: string;
  documentNo: string;
  modeOfPayment: string;
  status?: string;
  updatedAt: string;
  updatedby: string;
};

export type RequiredDocument = {
  checked: boolean;
  isExpiry: boolean;
  status: string;
  title: string;
  type: string;
};

export type ShippingDetail = {};

export const USAGE_TYPE = {
  RESIDENTIAL: "residential",
  COMMERCIAL: "commercial",
} as const;

export type UsageType = (typeof USAGE_TYPE)[keyof typeof USAGE_TYPE];

export type TenantType = "company" | "individual";

export type TenantDetails = {
  address?: string;
  city?: string;
  company?: string;
  companyPhone?: string;
  country?: string;
  createdAt: string;
  designation?: string;
  designationAsPerVisa: string;
  email: string;
  maritalStatus: string;
  mobileNumber: string;
  countryCode: string;
  workPhone: string;
  nationality: string;
  paymentPlanId: string;
  poBox?: string;
  tenantIdentityType: TenantType;
  tenantNameAR: string;
  tenantNameEN: string;
  tenantFirstNameEN: string;
  tenantLastNameEN: string;
  firstName: string;
  lastName: string;
  tenantType: string;
  tradeLicense?: string;
  updatedAt: string;
};

export type AdminManager = {
  email: string;
  name: string;
  userId: string;
};
